<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="detail_dialog" :top="'2vh'" :fullscreen="isExpand"
    :show-close="false" :before-close="handleClose" width="1200px">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>商机详情</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <div class="content__main">
        <div class="content__main-flag">
          <img :src="flagSvg">
        </div>
        <div class="content__main-header">
          <div class="content__main-header-order">商机号：{{ detail.code }}</div>
          <div class="content__main-header-name">
            <template v-if="detail.releaseTenantIsPersonal">
              {{ detail.businessTypeDesc }}_{{ detail.code }}
            </template>
            <template v-else>
              {{ detail.inquirePriceParty || '--' }}_{{ detail.businessTypeDesc }}_{{ detail.code }}
            </template>
            <span v-if="detail.inquireTenantStatusDesc" :class="['c_tag', detail.inquireTenantStatus ? detail.inquireTenantStatus.toLowerCase() : '']">
              {{ detail.inquireTenantStatusDesc }}
            </span>
            <span v-if="detail.inquireTenantStatus === 'CLOSED'"
              :class="['c_reason', detail.inquireTenantStatus ? detail.inquireTenantStatus.toLowerCase() : '']">
              <i class="el-icon-warning-outline"></i>关单原因：{{ detail.closeReason }}
            </span>
          </div>
        </div>
        <div :class="['content__main-bizOppStatus', `bizOppStatus-${bizOppStatus}`]">
          {{ bizOppStatus | filterBizOppStatus }}
        </div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="商机信息" name="order">
          <component :is="orderComponent" class="pane" :info="detail" :isEncryptable="isEncryptable"></component>
        </el-tab-pane>
        <el-tab-pane label="日志动态" name="log">
          <Log ref="log" class="pane" :id="id"></Log>
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import MaintainOrder from './maintain/order.vue';
import SparepartOrder from './sparepart/order.vue';
import Log from './log.vue';
import * as Moment from 'dayjs';
import { queryBizOppDetail } from '@/api/businessOpportunity.js';

const componentMap = {
  MAINTAIN: {
    orderComponent: MaintainOrder,
  },
  SPARE_PART: {
    orderComponent: SparepartOrder,
  },
};

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
    isEncryptable: {
      type: Boolean,
      default: false,
    },
    bizOppStatus: {
      type: String,
      default: '',
    },
  },
  provide () {
    return {
      closeDialog: this.handleClose,
    };
  },
  components: {
    MaintainOrder,
    Log,
  },
  computed: {
    orderComponent () {
      return componentMap[this.type].orderComponent;
    },
  },
  filters: {
    filterBizOppStatus (status) {
      // 商机状态【BE_BEING：进行中；FULL：已满额；FINISHED：已关单】
      switch (status) {
      case 'BE_BEING':
        return '进行中';
      case 'FULL':
        return '已满额';
      case 'FINISHED':
        return '已关单';
      default:
        return '';
      }
    },
  },
  watch: {
    activeName (name) {
      if (name === 'order') {
        this.getDetail();
      } else if (name === 'price') {
        this.$refs.price.getDetail();
      } else if (name === 'log') {
        this.$refs.log.init();
      }
    },
  },
  data () {
    return {
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'), // eslint-disable-line
      collapseSvg: require('@/assets/ic_collapse.svg'), // eslint-disable-line
      flagSvg: require('@/assets/ic_niche.svg'), // eslint-disable-line
      activeName: 'order',
      detail: {},
      contactInfo: {
        name: '',
        phone: '',
      },
    };
  },
  methods: {
    handleClose () {
      this.$emit('update:dialogVisible', false);
    },
    formatDate (text) {
      return text ? Moment(text).format('YYYYMMDD') : '';
    },
    getDetail () {
      // let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      queryBizOppDetail({
        // tenantId: userInfo.tenantId,
        id: this.id,
      }).then(({ body }) => {
        this.detail = body || {};
        this.contactInfo = {
          name: body.createUserName,
          phone: body.createUserPhone,
        };
      });
    },
  },
  mounted () {
    this.getDetail();
  },
};
</script>

<style scoped lang="scss">
.detail_dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }

  .content__main {
    display: flex;
    align-items: center;
    position: relative;

    .content__main-header {
      margin-left: 12px;

      .content__main-header-order {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
      }

      .content__main-header-name {
        height: 32px;
        line-height: 32px;
        font-size: 16px;
        font-weight: 600;

        .c_tag {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
        }

        .c_reason {
          font-size: 12px;
          color: #FAB007;
          margin-left: 8px;
        }

        .wait_task_order {
          background-color: #FEFAE0;
          color: #FAB007;
        }

        .wait_quote_price {
          background-color: #FEFAE0;
          color: #FAB007;
        }

        .quoted {
          background-color: #E5FEEB;
          color: #14CA64;
        }

        .negotiating {
          background-color: #E2F3FE;
          color: #237FFA;
        }

        .entered {
          background-color: #E5FEEB;
          color: #14CA64;
        }

        .rejected {
          background-color: #FEE9E5;
          color: #FF5959;
        }

        .closed {
          background-color: #F2F4F7;
          color: #1F2733;
        }
      }
    }
    .content__main-bizOppStatus {
      margin-left: 20px;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 13px;
      color: #fff;
      &.bizOppStatus-BE_BEING {
        background: #237FFA;
      }
      &.bizOppStatus-FULL {
        background: #14CA64;
      }
      &.bizOppStatus-FINISHED {
        background: #F2F4F7;
        color: #1F2733;
      }
    }
  }

  .pane {
    height: calc(90vh - 220px);
    overflow: auto;
  }
}
</style>
